<script setup lang="ts">
import { ref, onMounted, defineProps, defineEmits } from 'vue'

// Extend Window interface to allow adding the oo_oo function
declare global {
  interface Window {
    oo_oo: (...args: any[]) => any;
  }
}

const props = defineProps({
  // Expose the deep-chat props we need
  onNewMessage: Function,
  submitButtonStyles: Object,
  chatStyle: Object,
  introMessage: Object,
  avatars: Object,
  messageStyles: Object,
  inputAreaStyle: Object,
  textInput: Object,
  auxiliaryStyle: Object,
  requestBodyLimits: Object,
  connect: Object,
  history: Array
})

const emit = defineEmits(['chat-loaded', 'chat-error'])
const isLoaded = ref(false)
const hasError = ref(false)
const errorMessage = ref('')
const chatEl = ref(null)

// Load deep-chat safely
onMounted(async () => {
  try {
    // Try to patch any TypeScript syntax issues before loading
    if (typeof window !== 'undefined') {
      // Create a patch function to fix the common TS syntax error
      window.oo_oo = function(...args) {
        // This is a no-op replacement for the problematic function
        return null
      }
    }
    
    // Now try to load deep-chat
    await import('deep-chat')
    isLoaded.value = true
    emit('chat-loaded', true)
  } catch (error) {
    console.error('Failed to load deep-chat component:', error)
    hasError.value = true
    errorMessage.value = error.message || 'Failed to load chat component'
    emit('chat-error', error)
  }
})
</script>

<template>
  <div v-if="isLoaded" ref="chatEl">
    <deep-chat
      v-bind="$props"
      id="deepchat"
    />
  </div>
  <div v-else-if="hasError" class="flex h-full w-full justify-center items-center p-4">
    <div class="flex flex-col items-center text-center">
      <span class="text-sm text-red-500">Could not load chat component</span>
      <p class="text-xs text-muted-foreground mt-2">Please try refreshing the page</p>
    </div>
  </div>
  <div v-else class="flex h-full w-full justify-center items-center">
    <div class="animate-pulse flex flex-col items-center">
      <span class="text-sm text-muted-foreground">Loading chat...</span>
      <div class="mt-2 w-8 h-8 rounded-full border-2 border-t-transparent border-primary animate-spin"></div>
    </div>
  </div>
</template> 